// Spinner.tsx
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled.div`
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 4px solid #ccc;
  border-top-color: #333;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const Spinner = () => <SpinnerWrapper />;

export default Spinner;